import styled from "styled-components";

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
